import React, { useState } from "react";
import { format } from "date-fns";
import { FormGroup, Label, Input, ButtonGroup, Title } from "./styles";
import {
  BlueTitle,
  ModalBody,
  ModalContainer,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Space,
} from "../../shared/styles/global.styles";
import Button from "../Button/button";
import { IoCloseSharp } from "react-icons/io5";
import InputComponent from "../Input/input";

interface FecharCaixaModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (valorFechamento: number) => void;
}

const FecharCaixaModal: React.FC<FecharCaixaModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  const [valorFechamento, setValorFechamento] = useState<string>("R$0,00");

  const handleConfirm = async () => {
    const valor = valorFechamento.replace("R$", "").replace(",", ".").trim();

    onClose(); // Fecha o modal imediatamente
    try {
      await onConfirm(Number(valor)); // Supondo que onConfirm seja uma função assíncrona
    } catch (error) {
      console.error("Erro ao fechar o caixa:", error);
    } finally {
      limparModal(); // Limpa o modal após a confirmação
    }
  };

  const limparModal = () => {
    setValorFechamento("R$0,00");
  };

  // const isValorValido = () => {
  //   const valor = parseFloat(
  //     valorFechamento.replace(",", ".").replace("R$", "").trim()
  //   );
  //   return !isNaN(valor);
  // };

  if (!isOpen) return null;

  return (
    <ModalContainer show={isOpen}>
      <ModalContent width={25}>
        <Button
          type="button"
          schemaButton="x-close"
          action={() => onClose()}
          icon={<IoCloseSharp size={30} />}
          position="absolute"
          top={10}
          right={10}
        />
        <ModalHeader>
          <BlueTitle>Fechar caixa</BlueTitle>
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label>Data do caixa</Label>
            <InputComponent
              type="text"
              name="dataFechamento"
              id="dataFechamento"
              value={format(new Date(), "dd/MM/yyyy")}
              // onChange={(e) => {
              //   null;
              // }}
              placeholder="00/00/0000"
              disabled={true}
              color="black"
            />
          </FormGroup>

          {/* <FormGroup>
            <Label>Valor de fechamento do caixa</Label>
            <InputComponent
              type="text"
              name="valorFechamento"
              id="valorFechamento"
              value={valorFechamento}
              onChange={(e) => {
                const formatted = e.target.value
                  .replace(/\D/g, "")
                  .replace(/(\d)(\d{2})$/, "$1,$2")
                  .replace(/(?=(\d{3})+(\D))\B/g, ".");
                setValorFechamento("R$ " + formatted);
                //setValorFechamento(valorFechamento);
              }}
              placeholder="R$ 0,00"
              color="black"
            />
          </FormGroup> */}
        </ModalBody>
        <ModalFooter>
          <Button schemaButton="out-danger" action={onClose}>
            Cancelar
          </Button>
          <Button
            schemaButton="full-primary"
            action={handleConfirm}
            // disabled={!isValorValido()}
          >
            Fechar caixa
          </Button>
        </ModalFooter>
      </ModalContent>
    </ModalContainer>
  );
};

export default FecharCaixaModal;
